import { Avatar, Box, Button, Grid, Group, Loader, Paper, Stack, Text, Title, useMantineTheme } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useState } from "react";
import { CONNECT_TWILIO, DISCONNECT_TWILIOS, GET_ALL_PHONES, GET_ALL_TWILIOS, SAVE_PHONE } from "../../services/phones";
import InputField, { InputFieldTypes } from "../input_field";

export default function Twilio({ connectOnly = false, default: defaultSettings = false }) {
    const [items, setItems] = useState<any[]>([]);
    const [phones, setPhones] = useState<any[]>([]);
    const [data, setData] = useState<any>(null);
    const [connecting, setConnecting] = useState<any>({});
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [loadingItems, setLoadingItems] = useState<boolean>(false);

    const theme = useMantineTheme();

    const handleChange = (dt: any) => setData((u: any) => ({ ...u, ...dt }))

    const loadData = () => {
        setLoadingItems(true)
        GET_ALL_TWILIOS()
            .then((res) => {
                setItems(res.filter((it: any) => it.is_default === defaultSettings))
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingItems(false)
            })
    }

    const loadPhones = () => {
        if (!connectOnly) {
            GET_ALL_PHONES()
                .then((res) => {
                    setPhones(res)
                })
                .catch(err => {
                    notifications.show({ title: "Ops.", message: err.message, color: 'red' })
                })
        }
    }

    const handleSave = () => {
        setLoadingSave(true)
        CONNECT_TWILIO({ ...data, default: defaultSettings })
            .then((res) => {
                loadData();
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingSave(false)
            })
    }

    const handleDisconnect = () => {
        setLoadingSave(true)
        DISCONNECT_TWILIOS()
            .then((res) => {
                loadData();
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
            .finally(() => {
                setLoadingSave(false)
            })
    }

    React.useEffect(() => { loadData() }, [])
    React.useEffect(() => { loadPhones() }, [])

    return <Stack>
        <Group>
            <Avatar size={40} src="/assets/twilio.png" />
            <Title style={{ flex: 1 }} c="gray.0" order={5}>Twilio</Title>
            {items.length > 0 && <Button
                size="sm"
                onClick={handleDisconnect}
                loading={loadingSave}
                color="red"
            >Disconnect</Button>}
        </Group>
        {
            (items.length > 0 && !connectOnly && true)
                ? <Grid>
                    {items.map(twilio => (
                        (twilio.availablePhones ?? []).map((ph: any) => {
                            const isConnected = phones.some(p => p.number === ph.phoneNumber);
                            return (
                                <Grid.Col span={{ base: 12, md: 4 }}>
                                    <Paper p="md" shadow="xs" style={{ backgroundColor: theme.colors.dark[8] }}>
                                        <Stack>
                                            <Text c="gray.0" ta="center" size="sm">{ph.phoneNumber}</Text>
                                            <Button
                                                size="xs"
                                                variant={isConnected ? 'filled' : "outline"}
                                                loading={connecting[ph.sid]}
                                                onClick={() => {
                                                    setConnecting((c: any) => ({ ...c, [ph.sid]: true }));
                                                    SAVE_PHONE({
                                                        type: "new",
                                                        number: ph.phoneNumber,
                                                        twilio_id: twilio.id,
                                                        sid: ph.sid
                                                    })
                                                        .then(() => {
                                                            loadPhones();
                                                            loadData();
                                                            notifications.show({ message: "Phone connected", color: "green" })
                                                        })
                                                        .catch((err) => {
                                                            notifications.show({ title: "Ops.", message: err.message, color: 'red' })
                                                        })
                                                        .finally(() => {
                                                            setConnecting((c: any) => ({ ...c, [ph.sid]: false }));
                                                        })
                                                }}
                                            >
                                                {isConnected ? 'Reconnect' : 'Connect'}
                                            </Button>
                                        </Stack>
                                    </Paper>
                                </Grid.Col>
                            )
                        })
                    ))}
                </Grid>
                : loadingItems
                    ? <Loader />
                    : <Stack>
                        <Group align="flex-end">
                            <Box style={{ flex: 1 }}>
                                <InputField
                                    name="account_sid"
                                    value={items[0]?.account_sid ?? data?.account_sid}
                                    readOnly={items.length > 0}
                                    fieldType={InputFieldTypes.PASSWORD}
                                    onChange={handleChange}
                                    title="Account SID"
                                    placeholder="Paste your ACCOUNT SID"
                                />
                            </Box>
                            <Box style={{ flex: 1 }}>
                                <InputField
                                    name="auth_token"
                                    value={items[0]?.auth_token ?? data?.auth_token}
                                    readOnly={items.length > 0}
                                    fieldType={InputFieldTypes.PASSWORD}
                                    onChange={handleChange}
                                    title="Auth Token"
                                    placeholder="Paste your AUTH TOKEN"
                                />
                            </Box>
                            {items.length === 0 && <Button
                                disabled={
                                    ((data?.account_sid ?? "").length < 10) || (data?.auth_token ?? "").length < 10
                                }
                                size="md"
                                onClick={handleSave}
                                loading={loadingSave}
                                color="green"
                            >Connect</Button>
                            }
                        </Group>
                    </Stack>
        }
    </Stack>
}
